// i18n types
export var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["ES"] = "es";
    LANGUAGES["PT"] = "pt";
    LANGUAGES["EN"] = "en";
})(LANGUAGES || (LANGUAGES = {}));
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["FACEBOOK"] = "facebook";
    AuthProvider["GOOGLE"] = "google-oauth2";
    AuthProvider["LINKEDIn"] = "linkedin";
    AuthProvider["TWITTER"] = "twitter";
})(AuthProvider || (AuthProvider = {}));
export var TimeZonesEnum;
(function (TimeZonesEnum) {
    // UTC+1
    TimeZonesEnum["TIME_ZONE_ES_ES"] = "Europe/Madrid";
    // UTC-3
    TimeZonesEnum["TIME_ZONE_PT_BR"] = "America/Sao_Paulo";
    TimeZonesEnum["TIME_ZONE_ES_AR"] = "America/Argentina/Buenos_Aires";
    TimeZonesEnum["TIME_ZONE_ES_UY"] = "America/Montevideo";
    // UTC-4
    TimeZonesEnum["TIME_ZONE_ES_PY"] = "America/Asuncion";
    TimeZonesEnum["TIME_ZONE_ES_CL"] = "America/Santiago";
    TimeZonesEnum["TIME_ZONE_ES_DO"] = "America/Santo_Domingo";
    TimeZonesEnum["TIME_ZONE_ES_PR"] = "America/Puerto_Rico";
    TimeZonesEnum["TIME_ZONE_HT"] = "America/Port-au-Prince";
    TimeZonesEnum["TIME_ZONE_ES_CU"] = "America/Havana";
    TimeZonesEnum["TIME_ZONE_ES_BO"] = "America/La_Paz";
    TimeZonesEnum["TIME_ZONE_ES_VE"] = "America/Caracas";
    // UTC-5
    TimeZonesEnum["TIME_ZONE_ES_PE"] = "America/Lima";
    TimeZonesEnum["TIME_ZONE_ES_CO"] = "America/Bogota";
    TimeZonesEnum["TIME_ZONE_EC_GUAYAQUIL"] = "America/Guayaquil";
    TimeZonesEnum["TIME_ZONE_PA"] = "America/Panama";
    // UTC-6
    TimeZonesEnum["TIME_ZONE_ES_MX"] = "America/Mexico_City";
    TimeZonesEnum["TIME_ZONE_EC_GALAPAGOS"] = "Pacific/Galapagos";
    TimeZonesEnum["TIME_ZONE_BZ"] = "America/Belize";
    TimeZonesEnum["TIME_ZONE_CR"] = "America/Costa_Rica";
    TimeZonesEnum["TIME_ZONE_GT"] = "America/Guatemala";
    TimeZonesEnum["TIME_ZONE_HN"] = "America/Tegucigalpa";
    TimeZonesEnum["TIME_ZONE_NI"] = "America/Managua";
    TimeZonesEnum["TIME_ZONE_SV"] = "America/El_Salvador";
})(TimeZonesEnum || (TimeZonesEnum = {}));
//# sourceMappingURL=types.js.map